export function decodeBase64ToObject<T>(encodedString: string): T {
  if (!encodedString) {
    return null
  }

  const jsonString = atob(encodedString)
  const obj = JSON.parse(jsonString) as T

  return obj
}

export function encodeObjectToBase64<T>(obj: T): string {
  const jsonString = JSON.stringify(obj)
  const encodedString = btoa(jsonString)

  return encodedString
}
